import { ODataSelect } from "@iconics/core";

export class Solution extends ODataSelect
{
    public Id = '';
    public Name = '';
    public IconUri: string | null = '';
    public ApplicationUri = '';

    public toSelect(): string
    {
        return 'ID,Name,IconUri,ApplicationUri';
    }
}
